// Module
var code = "<div> <div class=\"jh-footer\" ng-class=\"staticClass + ' ' +  sharedClass\"> <ng-transclude></ng-transclude> </div> <div class=\"jh-footer hidden\" ng-class=\"(fixedClass || '') + ' ' + (sharedClass || '')\" style=\"position:fixed;bottom:0;left:15px;right:31px\"> <ng-transclude></ng-transclude> </div> </div> ";
// Exports
module.exports = code;